import React from 'react';
import './ClearedButton.css';

const ClearedButton = (props: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) => (
  <button type="button" {...props} className={`${props.className} cleared_button`} />
);
export default ClearedButton;
